import { IAppState } from './app.types'
import StoreFactory from '@/generics/common/generics.store-factory'

export default new StoreFactory<IAppState>({
  state: {
    autoRefreshDataPingInMS: 19000,
    isLoading: false,
    accountID: 0,
    notificationIntervalID: null,
    itemEventForLinkedTaskID: null,
    error: null,
    lastVisitedBreadcrumbDataFromListing: null,
    lastVisitedBreadcrumbItemMenuItems: null,
    lastVisitedEntityLandingMemberData: null,
  },
}).storeOptions()
